// Vendor
import { EventEmitter } from '@angular/core';
// Services
import { NotificationsService } from 'NotificationsApp/ts/services/notifications.service';
import * as i0 from "@angular/core";
import * as i1 from "NotificationsApp/ts/services/notifications.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
const _c0 = ["ycn-notifications-menu-list-item", ""];
const _c1 = a0 => ({ "unread": a0 });
function NotificationsMenuListItemComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.errorMessage);
} }
function NotificationsMenuListItemComponent_div_5_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵlistener("click", function NotificationsMenuListItemComponent_div_5_span_4_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.toggleExpanded()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.expanded ? "Less" : "More");
} }
function NotificationsMenuListItemComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementContainerStart(1);
    i0.ɵɵtext(2);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtext(3, "\u00A0 ");
    i0.ɵɵtemplate(4, NotificationsMenuListItemComponent_div_5_span_4_Template, 2, 1, "span", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.expandable && ctx_r0.expanded || !ctx_r0.expandable ? ctx_r0.notification.message : ctx_r0.notification.message.slice(0, 30) + "...", " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.expandable);
} }
export class NotificationsMenuListItemComponent {
    constructor(notificationsService) {
        this.notificationsService = notificationsService;
        this.removeNotification = new EventEmitter();
        this.expandable = false;
        this.expanded = false;
        this.bulletColor = 'bullet-green';
    }
    ngOnInit() {
        this.expandable = !!this.notification.message && this.notification.message.length > 30;
        this.bulletColor = this.getBulletColor();
    }
    deleteNotification() {
        this.notificationsService.deleteNotification(this.notification).subscribe({
            next: () => {
                this.removeNotification.emit(this.notification);
            },
            error: (rsp) => {
                this.errorMessage = rsp.error;
            },
        });
    }
    getBulletColor() {
        if (this.notification.read) {
            return 'bullet-gray-70';
        }
        return 'bullet-green';
    }
    markNotificationRead() {
        if (!this.notification.read) {
            this.notificationsService.markNotificationAsRead(this.notification).subscribe({
                next: () => {
                    this.notification.read = true;
                    this.bulletColor = this.getBulletColor();
                },
                error: (rsp) => {
                    this.errorMessage = rsp.error;
                },
            });
        }
    }
    toggleExpanded() {
        this.expanded = !this.expanded;
    }
}
NotificationsMenuListItemComponent.ɵfac = function NotificationsMenuListItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NotificationsMenuListItemComponent)(i0.ɵɵdirectiveInject(i1.NotificationsService)); };
NotificationsMenuListItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NotificationsMenuListItemComponent, selectors: [["tr", "ycn-notifications-menu-list-item", ""]], inputs: { notification: "notification" }, outputs: { removeNotification: "removeNotification" }, standalone: false, attrs: _c0, decls: 12, vars: 11, consts: [["data-test-id", "notification-body", 3, "click"], ["data-test-id", "notification-error", "class", "text-red", "style", "display: flex; justify-content: center; align-items: center", 4, "ngIf"], ["data-test-id", "notification-title", 1, "notification-title", 3, "ngClass"], [1, "bullet", 3, "ngClass"], [3, "innerHTML"], ["class", "notification-descr", 4, "ngIf"], ["data-test-id", "notification-date", 1, "notification-date"], ["data-test-id", "notification-delete-btn", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-close", 3, "click"], ["ycnIcon", "", "name", "icon-close-circle"], ["data-test-id", "notification-error", 1, "text-red", 2, "display", "flex", "justify-content", "center", "align-items", "center"], [1, "notification-descr"], ["data-test-id", "notification-readmore", "class", "readmore", 3, "click", 4, "ngIf"], ["data-test-id", "notification-readmore", 1, "readmore", 3, "click"]], template: function NotificationsMenuListItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "td", 0);
        i0.ɵɵlistener("click", function NotificationsMenuListItemComponent_Template_td_click_0_listener() { return ctx.markNotificationRead(); });
        i0.ɵɵtemplate(1, NotificationsMenuListItemComponent_div_1_Template, 2, 1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelement(3, "div", 3)(4, "span", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, NotificationsMenuListItemComponent_div_5_Template, 5, 2, "div", 5);
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵtext(7);
        i0.ɵɵpipe(8, "date");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(9, "td")(10, "div", 7);
        i0.ɵɵlistener("click", function NotificationsMenuListItemComponent_Template_div_click_10_listener() { return ctx.deleteNotification(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(11, "svg", 8);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.errorMessage);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c1, !ctx.notification.read));
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", ctx.bulletColor);
        i0.ɵɵadvance();
        i0.ɵɵproperty("innerHTML", ctx.notification.label, i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.notification.message);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(8, 6, ctx.notification.create_date, "MMM d, y 'at' h:mm a"));
    } }, dependencies: [i2.NgClass, i2.NgIf, i3.IconDirective, i2.DatePipe], encapsulation: 2 });
